import { AxiosPromise } from 'axios';
import { PostTimeLineType } from '../../types/models/Post';
import client from '../client';


type fixPostToTeamResponse= {
    team_post_fix_uuid:string
}
type fixPostToTeamParams = {
    postUuid: string
}

export const fixPostToTeam = ( { postUuid }: fixPostToTeamParams ): AxiosPromise<fixPostToTeamResponse> =>{
    const data = new FormData()
    data.append( "post_uuid", postUuid)
    return client.post( `api/team/fixed_posts/`, data)
}


type releasePostToTeamResponse = {
    detail: string
}
type releasePostToTeamParams = {
    fix_uuid: string
}

export const releasePostToTeam = ( { fix_uuid }: releasePostToTeamParams ): AxiosPromise<releasePostToTeamResponse> => {
    return client.delete( `api/team/fixed_posts/${fix_uuid}/` )
}


type getFixedPostsResponse = {
    fixed_posts: PostTimeLineType[]
}
export const getFixedPosts = (): AxiosPromise<getFixedPostsResponse> => {
    return client.get( `api/team/fixed_posts/` )
}
